var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehicleWidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 369,
    viewBox: "0 0 352 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 272.76C86.8586 273.803 29.7716 269.038 27.9145 269.038C26.0574 269.038 25.8271 266.298 25.8271 266.298V247.029L27.5231 250.029H34.1228C34.1228 250.029 34.4834 234.551 34.7137 229.064C34.9439 223.577 39.6711 223.8 40.5536 223.262C41.4361 222.725 41.5052 221.62 41.5052 221.62C41.2596 217.261 36.0182 216.133 36.0182 216.133C30.4316 216.133 28.6742 222.203 28.6742 222.203C29.0656 215.151 31.6134 209.273 31.6134 209.273L37.2614 69.9663L39.1569 68.5927V56.9052H37.2V52.531C37.2 52.531 36.4787 39.7921 50.3917 29.931C64.3046 20.0699 109.957 9.42607 109.957 9.42607C109.957 9.42607 136.118 1 177.964 1",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.942 9.42603V56.6442H177.949",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.942 56.6443H39.1494",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5625 33.0312V56.6442L40.124 143.445H71.48H177.949",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 60.7576H108.377H58.7411L56.0015 138.15H177.949",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2111 60.7576L51.4892 138.15H43.4622L49.3328 60.7576H55.2111Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4799 143.445C71.4799 143.445 56.293 142.662 56.0014 164.211L53.5227 168.393V202.228C53.5227 202.228 66.8448 204.384 73.3753 213.593C79.9059 222.802 87.6106 265.316 87.6106 265.316C87.6106 265.316 25.8271 263.881 25.8271 263.751",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5151 168.393C53.5151 168.393 54.6279 175.384 78.5938 192.95C78.5938 192.95 84.5335 196.672 84.3416 208.889L87.6108 252.516L86.0453 200.401C86.0453 200.401 85.9762 194.262 82.2543 191.124C78.5324 187.985 58.0275 172.115 56.0015 164.219",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 194.385L107.724 195.82C107.724 195.82 100.02 195.229 99.7587 203.264C99.4977 211.299 98.2546 227.56 99.7587 258.387C99.7587 258.387 100.741 264.457 108.377 265.308C116.02 266.16 177.949 266.352 177.949 266.352",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 204.377H115.69C115.69 204.377 113.211 236.186 115.69 256.951H177.949",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7586 203.264C99.7586 203.264 98.9068 195.068 105.176 194.385C111.446 193.702 177.949 192.82 177.949 192.82",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0898 253.951H39.6864C37.5607 253.951 35.8264 252.217 35.8264 250.091V229.463C35.8264 227.337 37.5607 225.603 39.6864 225.603H64.0898C66.2155 225.603 67.9498 227.337 67.9498 229.463V250.091C67.9498 252.209 66.2155 253.951 64.0898 253.951Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4351 252.508H39.6327C38.5046 252.508 37.5837 251.587 37.5837 250.459V229.494C37.5837 228.366 38.5046 227.445 39.6327 227.445H64.4351C65.5632 227.445 66.4841 228.366 66.4841 229.494V250.459C66.4841 251.587 65.5555 252.508 64.4351 252.508Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1945 248.364H43.631C42.2958 248.364 41.2061 247.274 41.2061 245.939V234.328C41.2061 232.993 42.2958 231.903 43.631 231.903H62.1945C63.5298 231.903 64.6195 232.993 64.6195 234.328V245.939C64.6195 247.274 63.5298 248.364 62.1945 248.364Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3965 211.138H39.0496H38.2285C36.5786 211.138 35.2356 209.787 35.2356 208.145V201.039C35.2356 199.389 36.5862 198.046 38.2285 198.046H48.4042C50.0541 198.046 51.3971 199.396 51.3971 201.039V208.145C51.3971 209.787 50.0464 211.138 48.3965 211.138Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0495 211.137L37.5837 215.251C37.5837 215.251 46.547 213.34 49.4401 213.194L48.4041 211.137",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1581 166.69C50.3161 166.69 54.4974 162.508 54.4974 157.35C54.4974 152.192 50.3161 148.011 45.1581 148.011C40.0002 148.011 35.8188 152.192 35.8188 157.35C35.8188 162.508 40.0002 166.69 45.1581 166.69Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.158 165.063C49.3793 165.063 52.8013 161.641 52.8013 157.419C52.8013 153.198 49.3793 149.776 45.158 149.776C40.9367 149.776 37.5146 153.198 37.5146 157.419C37.5146 161.641 40.9367 165.063 45.158 165.063Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0945 172.576H36.6629V195.298",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40959 151.019H29.0964C29.0964 151.019 31.5751 150.82 31.836 152.585C32.0969 154.35 32.4269 159.054 31.836 162.776C31.2451 166.498 27.1318 173.42 22.9571 176.62C18.7748 179.82 12.7661 175.707 12.7661 175.707C12.7661 175.707 4.40906 168.393 1.13993 157.419C1.13993 157.419 -0.49464 151.019 7.40959 151.019Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.836 152.585C31.836 152.585 30.071 152.654 29.6182 157.419C29.1655 162.185 29.6182 168.409 29.6182 168.409",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7661 175.707V187.333C12.7661 187.333 13.4798 194.385 16.5801 194.385C19.6804 194.385 22.0363 194.385 22.0363 194.385C22.0363 194.385 25.6968 195.106 25.8273 198.046C25.9577 200.985 25.8273 247.029 25.8273 247.029",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5801 177.448V187.985C16.5801 187.985 16.8717 191.185 19.3197 191.384C21.7754 191.584 23.3409 191.384 23.3409 191.384C23.3409 191.384 28.1064 191.315 28.0451 195.958C27.976 200.593 28.6666 222.211 28.6666 222.211L27.5232 250.037",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2713 110.784H10.9934C7.93912 110.784 5.44507 108.283 5.44507 105.236V65.2622C5.44507 62.2079 7.94679 59.7139 10.9934 59.7139H20.2713C23.3255 59.7139 25.8196 62.2156 25.8196 65.2622V105.236C25.8273 108.29 23.3255 110.784 20.2713 110.784Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2711 140.437C27.9551 140.437 34.1841 134.208 34.1841 126.524C34.1841 118.84 27.9551 112.611 20.2711 112.611C12.5872 112.611 6.35815 118.84 6.35815 126.524C6.35815 134.208 12.5872 140.437 20.2711 140.437Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6362 59.7139V56.6443",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6537 58.1791H12.4976V56.6443H27.6537",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6536 114.737V50.4361L29.8714 47.8269L37.1924 52.5311",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7847 117.422V51.4873L37.1925 56.9052",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0148 135.364C31.0148 135.364 30.7539 137.298 34.1842 137.689",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2445 137.927C28.2445 137.927 27.362 140.567 34.399 140.437",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9146 269.038V272.906V274.064",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 331.927C177.949 331.927 127.707 331.927 109.489 331.927C91.2711 331.927 80.0978 313.217 80.0978 313.217C80.0978 313.217 31.3831 313.217 27.1471 313.217C22.911 313.217 22.934 308.283 22.934 308.283C22.934 308.283 22.9571 277.211 22.934 275.5C22.911 273.788 24.7758 272.906 24.7758 272.906C24.7758 272.906 90.6419 279.904 177.949 277.848",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9237 282.943H51.8882V308.022H78.9237V282.943Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 281.186H154.751V302.42H177.949",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0371 312.534H177.949",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1472 313.217V355.248C27.1472 355.248 27.293 368.378 32.4883 368.378C37.6836 368.378 62.2712 368.378 62.2712 368.378C62.2712 368.378 67.4665 367.695 67.9499 355.639C68.4411 343.591 67.9499 313.217 67.9499 313.217",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7185 47.8268C66.6433 47.8268 70.6357 43.8345 70.6357 38.9096C70.6357 33.9848 66.6433 29.9924 61.7185 29.9924C56.7936 29.9924 52.8013 33.9848 52.8013 38.9096C52.8013 43.8345 56.7936 47.8268 61.7185 47.8268Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5854 46.8598C93.5102 46.8598 97.5026 42.8674 97.5026 37.9426C97.5026 33.0178 93.5102 29.0254 88.5854 29.0254C83.6606 29.0254 79.6682 33.0178 79.6682 37.9426C79.6682 42.8674 83.6606 46.8598 88.5854 46.8598Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5625 53.9045H109.942",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M163.177 15.6958H154.95C153.653 15.6958 152.602 14.6367 152.602 13.3475C152.602 12.0506 153.661 10.9993 154.95 10.9993H163.177C164.474 10.9993 165.525 12.0583 165.525 13.3475C165.525 14.6367 164.466 15.6958 163.177 15.6958Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 207.838H115.375",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 211.368H115.375",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 214.89H115.375",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 218.42H115.375",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 221.943H114.593",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 225.473H114.593",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 229.003H114.615",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 232.525H114.615",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 236.055H114.593",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 239.577H114.593",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 243.107H114.738",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 246.63H114.615",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 250.16H115.375",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 253.69H115.375",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M120.072 204.377V256.951",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M142.211 204.592V256.951",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M151.221 204.377V256.951",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 204.377V256.951",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6536 193.848L79.5069 199.872V202.22L28.0449 195.951",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M108.376 60.7576V63.6353L161.803 97.7233L160.138 94.7995L113.503 63.6967V60.7576",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M108.376 63.6353L111.3 61.9854L113.503 63.6967L111.423 65.5768L108.376 63.6353Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 272.76C265.141 273.803 322.228 269.038 324.085 269.038C325.943 269.038 326.173 266.298 326.173 266.298V247.029L324.477 250.029H317.877C317.877 250.029 317.516 234.551 317.286 229.064C317.056 223.577 312.329 223.8 311.446 223.262C310.564 222.725 310.495 221.62 310.495 221.62C310.74 217.261 315.982 216.133 315.982 216.133C321.568 216.133 323.326 222.203 323.326 222.203C322.934 215.151 320.387 209.273 320.387 209.273L314.738 69.9663L312.843 68.5927V56.9052H314.8V52.531C314.8 52.531 315.521 39.7921 301.608 29.931C287.695 20.0699 242.043 9.42607 242.043 9.42607C242.043 9.42607 215.882 1 174.035 1",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M242.05 9.42603V56.6442H174.051",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M242.05 56.6443H312.851",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M305.438 33.0312V56.6442L311.868 143.445H280.52H174.051",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 60.7576H243.623H293.259L295.999 138.15H174.051",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M296.781 60.7576L300.503 138.15H308.538L302.66 60.7576H296.781Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M280.52 143.445C280.52 143.445 295.707 142.662 295.998 164.211L298.477 168.393V202.228C298.477 202.228 285.155 204.384 278.624 213.593C272.094 222.802 264.389 265.316 264.389 265.316C264.389 265.316 326.173 263.881 326.173 263.751",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M298.477 168.393C298.477 168.393 297.364 175.384 273.399 192.95C273.399 192.95 267.459 196.672 267.651 208.889L264.382 252.516L265.947 200.401C265.947 200.401 266.016 194.262 269.738 191.124C273.46 187.985 293.965 172.115 295.991 164.219",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 194.385L244.276 195.82C244.276 195.82 251.98 195.229 252.241 203.264C252.502 211.299 253.745 227.56 252.241 258.387C252.241 258.387 251.259 264.457 243.623 265.308C235.98 266.16 174.051 266.352 174.051 266.352",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 204.377H236.31C236.31 204.377 238.789 236.186 236.31 256.951H174.051",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M252.241 203.264C252.241 203.264 253.093 195.068 246.823 194.385C240.554 193.702 174.051 192.82 174.051 192.82",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M287.91 253.951H312.313C314.439 253.951 316.173 252.217 316.173 250.091V229.463C316.173 227.337 314.431 225.603 312.313 225.603H287.91C285.784 225.603 284.05 227.337 284.05 229.463V250.091C284.05 252.209 285.784 253.951 287.91 253.951Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M287.565 252.508H312.367C313.495 252.508 314.416 251.587 314.416 250.459V229.494C314.416 228.366 313.495 227.445 312.367 227.445H287.565C286.437 227.445 285.516 228.366 285.516 229.494V250.459C285.516 251.587 286.437 252.508 287.565 252.508Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M289.806 248.364H308.369C309.704 248.364 310.794 247.274 310.794 245.939V234.328C310.794 232.993 309.704 231.903 308.369 231.903H289.806C288.47 231.903 287.381 232.993 287.381 234.328V245.939C287.381 247.274 288.47 248.364 289.806 248.364Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M303.596 211.138H312.943H313.764C315.414 211.138 316.757 209.787 316.757 208.145V201.039C316.757 199.389 315.406 198.046 313.764 198.046H303.588C301.938 198.046 300.595 199.396 300.595 201.039V208.145C300.603 209.787 301.953 211.138 303.596 211.138Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M312.95 211.137L314.416 215.251C314.416 215.251 305.453 213.34 302.56 213.194L303.596 211.137",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M306.834 166.69C311.992 166.69 316.173 162.508 316.173 157.35C316.173 152.192 311.992 148.011 306.834 148.011C301.676 148.011 297.495 152.192 297.495 157.35C297.495 162.508 301.676 166.69 306.834 166.69Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M306.834 165.063C311.056 165.063 314.478 161.641 314.478 157.419C314.478 153.198 311.056 149.776 306.834 149.776C302.613 149.776 299.191 153.198 299.191 157.419C299.191 161.641 302.613 165.063 306.834 165.063Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M318.905 172.576H315.329V195.298",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M344.59 151.019H322.904C322.904 151.019 320.425 150.82 320.164 152.585C319.903 154.35 319.573 159.054 320.164 162.776C320.755 166.498 324.868 173.42 329.043 176.62C333.225 179.82 339.234 175.707 339.234 175.707C339.234 175.707 347.591 168.393 350.86 157.419C350.86 157.419 352.494 151.019 344.59 151.019Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M320.164 152.585C320.164 152.585 321.929 152.654 322.382 157.419C322.842 162.185 322.382 168.409 322.382 168.409",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M339.234 175.707V187.333C339.234 187.333 338.52 194.385 335.42 194.385C332.312 194.385 329.964 194.385 329.964 194.385C329.964 194.385 326.303 195.106 326.173 198.046C326.042 200.985 326.173 247.029 326.173 247.029",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M335.42 177.448V187.985C335.42 187.985 335.128 191.185 332.68 191.384C330.232 191.584 328.659 191.384 328.659 191.384C328.659 191.384 323.893 191.315 323.955 195.958C324.024 200.593 323.333 222.211 323.333 222.211L324.477 250.037",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M331.721 110.784H340.999C344.053 110.784 346.547 108.283 346.547 105.236V65.2622C346.547 62.2079 344.045 59.7139 340.999 59.7139H331.721C328.667 59.7139 326.173 62.2156 326.173 65.2622V105.236C326.173 108.29 328.667 110.784 331.721 110.784Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M331.721 140.437C339.405 140.437 345.634 134.208 345.634 126.524C345.634 118.84 339.405 112.611 331.721 112.611C324.037 112.611 317.808 118.84 317.808 126.524C317.808 134.208 324.037 140.437 331.721 140.437Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M336.364 59.7139V56.6443",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M324.346 58.1791H339.495V56.6443H324.346",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M324.346 114.737V50.4361L322.121 47.8269L314.807 52.5311",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M321.208 117.422V51.4873L314.807 56.9052",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M320.985 135.364C320.985 135.364 321.246 137.298 317.816 137.689",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M323.755 137.927C323.755 137.927 324.638 140.567 317.601 140.437",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M324.085 269.038V272.906V274.064",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 331.927C174.051 331.927 224.293 331.927 242.511 331.927C260.729 331.927 271.902 313.217 271.902 313.217C271.902 313.217 320.617 313.217 324.853 313.217C329.089 313.217 329.066 308.283 329.066 308.283C329.066 308.283 329.043 277.211 329.066 275.5C329.089 273.788 327.224 272.906 327.224 272.906C327.224 272.906 261.358 279.904 174.051 277.848",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M300.112 282.943H273.076V308.022H300.112V282.943Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 281.186H197.249V302.42H174.051",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M268.963 312.534H174.051",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M324.853 313.217V355.248C324.853 355.248 324.707 368.378 319.512 368.378C314.316 368.378 289.729 368.378 289.729 368.378C289.729 368.378 284.534 367.695 284.05 355.639C283.559 343.591 284.05 313.217 284.05 313.217",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M290.281 47.8268C295.206 47.8268 299.199 43.8345 299.199 38.9096C299.199 33.9848 295.206 29.9924 290.281 29.9924C285.357 29.9924 281.364 33.9848 281.364 38.9096C281.364 43.8345 285.357 47.8268 290.281 47.8268Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M263.407 46.8598C268.332 46.8598 272.324 42.8674 272.324 37.9426C272.324 33.0178 268.332 29.0254 263.407 29.0254C258.482 29.0254 254.49 33.0178 254.49 37.9426C254.49 42.8674 258.482 46.8598 263.407 46.8598Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M305.438 53.9045H242.05",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M188.823 15.6958H197.05C198.347 15.6958 199.398 14.6367 199.398 13.3475C199.398 12.0506 198.339 10.9993 197.05 10.9993H188.823C187.526 10.9993 186.475 12.0583 186.475 13.3475C186.475 14.6367 187.534 15.6958 188.823 15.6958Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 207.838H236.625",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 211.368H236.625",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 214.89H236.625",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 218.42H236.625",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 221.943H237.407",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 225.473H237.407",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 229.003H237.377",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 232.525H237.377",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 236.055H237.407",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 239.577H237.407",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 243.107H237.254",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 246.63H237.377",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 250.16H236.625",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 253.69H236.625",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M231.928 204.377V256.951",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M209.789 204.592V256.951",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M200.779 204.377V256.951",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949 204.377V256.951",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M324.346 193.848L272.485 199.872V202.22L323.955 195.951",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M243.623 60.7576V63.6353L190.197 97.7233L191.862 94.7995L238.489 63.6967V60.7576",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M243.623 63.6353L240.7 61.9854L238.49 63.6967L240.577 65.5768L243.623 63.6353Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M350.431 156.066C351.212 156.847 351.212 158.113 350.431 158.894L337.703 171.622C336.922 172.403 335.656 172.403 334.874 171.622C334.093 170.841 334.093 169.575 334.874 168.794L346.188 157.48L334.874 146.167C334.093 145.385 334.093 144.119 334.874 143.338C335.656 142.557 336.922 142.557 337.703 143.338L350.431 156.066ZM1.5044 158.894C0.723347 158.113 0.723347 156.847 1.5044 156.066L14.2323 143.338C15.0134 142.557 16.2797 142.557 17.0607 143.338C17.8418 144.119 17.8418 145.385 17.0607 146.167L5.74704 157.48L17.0607 168.794C17.8418 169.575 17.8418 170.841 17.0607 171.622C16.2797 172.403 15.0134 172.403 14.2323 171.622L1.5044 158.894ZM349.017 159.48L2.91861 159.48L2.91861 155.48L349.017 155.48L349.017 159.48Z",
    fill: "#2D9DC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleWidth);
export default __webpack_public_path__ + "static/media/vehicle-width.cb811cd907917118c1175d52e4d8f7cf.svg";
export { ForwardRef as ReactComponent };